import React from 'react'
import Base from './Base'



function Contact() {
    return (
        <div>
            <Base title="CoWin  Notifier" description="Get notified by email whenever slots open">

                <h5 className="text-white App"> Email:- dotlify@gmail.com </h5>
            </Base>
        </div>
    )
}

export default Contact
